
































import { Component, Vue } from "vue-property-decorator";
import { RedCapital,  SelectedCountry, RedCapitalConfig } from "@/configuration";
import { mapState } from "vuex";	



@Component({
    metaInfo: {
    title: "Cuenta bloqueada",
        htmlAttrs: {
            // @ts-ignore
            lang: RedCapital[SelectedCountry].Lang,
        },
    }, 
    computed: {
        ...mapState(["setOpenMenuPanel"]),
        setOpenMenuPanel(){
            return this.$store.state.openMenuPanel;
        }
    },
    methods: {
        goToHome(){
            this.$router.push("/");
        }
    }
})

export default class AccountBlocked extends Vue {}
